<template>
  <v-toolbar v-if="user"
             dense
             flat
             grow
             class="mb-4">
    <v-tabs>
      <v-tab :to="{name: 'library.show_profile'}"
             exact>
        Profile
      </v-tab>
      <v-tab :to="{name: 'library.edit_profile'}">
        Edit
      </v-tab>
      <!--<v-tab>
        Dashboard
      </v-tab>-->
      <!--<v-tab>
        Activity
      </v-tab>-->
      <v-tab v-if="user.can_change_password"
             :to="{name: 'library.change_password'}">
        Change My Password
      </v-tab>
      <v-tab v-if="user.can_use_tfa"
             :to="{name: 'library.setup_tfa'}">
        Security
      </v-tab>
      <!--<v-tab>
        API Tokens
      </v-tab>-->
      <!--<v-tab>
        Connections
      </v-tab>-->

    </v-tabs>
  </v-toolbar>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'isAdmin',
      'user',
    ]),
  }
}
</script>
